<template>
  <div class="col-md-12 grid-margin stretch-card">
					<div class="card activeCard">
						<div class="card-body">
							<div class="d-flex align-items-start justify-content-between pointer forceLTR">
							<h6 v-on:click="GoToAdmissionInfo" class="card-title flex-grow lower-line text-truncate">{{ $t('MdPatientRegistrationInfo.RegistrationInfo') }}</h6>
							<i class="mdi mdi-arrow-right-drop-circle text-corporate" v-on:click="GoToAdmissionInfo"></i>
							<b-button  v-on:click="DoReport()" style="position: relative; top: -4px;" class="repDateNotesBtn mx-2"  v-b-tooltip.hover :title="$t('MdPatientRegistrationInfo.AdmissionFaceSheet')">
								{{ $t('Shared.FS') }}
							</b-button>

							</div>
							<!--<div class="row">
							<div class="float-left col text-muted p-item" v-if="RegistrationInfo.programName">
							<small>{{ $tc('Shared.Program') }}</small><br>
							<b>{{RegistrationInfo.programName}}</b>
							</div>
							<div class="float-left col text-muted p-item" v-if="RegistrationInfo.dateFrom">
							<small>{{ $t('MdPatientRegistrationInfo.AdmissionDate') }}</small><br>
							<b>{{RegistrationInfo.dateFrom}}</b>
							</div>
							<div class="float-left col text-muted p-item"> 
							<small>{{ $t('MdPatientRegistrationInfo.DischargeDate') }}</small><br>
							<b>{{RegistrationInfo.dateTo}}</b>
							</div>
							</div>
							<div class="row">
							<div class="float-left col text-muted p-item" v-if="RegistrationInfo.status">
							<small>{{ $t('MdPatientRegistrationInfo.Status') }}</small><br>
							<b>{{RegistrationInfo.status}}</b>
							</div>
							<div class="float-left col text-muted p-item" v-if="RegistrationInfo.chartNo">
							<small>{{ $t('MdPatientRegistrationInfo.ChartNo') }}</small><br>
							<b>{{RegistrationInfo.chartNo}}</b>
							</div>
							</div>
							<div class="row">
							<div class="float-left col text-muted p-item" v-if="RegistrationInfo.roomName">
							<small>{{ this.$tc('Shared.Room') }}</small><br>
							<b>{{RegistrationInfo.roomName}}</b>
							</div>
							<div class="float-left col text-muted p-item" v-if="RegistrationInfo.buildingName">
							<small>{{ $t('Shared.BuildingName') }}</small><br>
							<b>{{RegistrationInfo.buildingName}}</b>
							</div>
							</div>-->
							<div class="flex-container">
								<div class="row">
									<div class="col-md-4" v-if="RegistrationInfo.programName">
										<div class="float-left col text-muted p-item">
											<small>{{ $tc('Shared.Program') }}</small><br>
											<b>{{RegistrationInfo.programName}}</b>
										</div>
									</div>
									<div class="col-md-4" v-if="RegistrationInfo.dateFrom">
										<div class="float-left col text-muted p-item">
											<small>{{ $t('MdPatientRegistrationInfo.AdmissionDate') }}</small><br>
											<b>{{RegistrationInfo.dateFrom}}</b>
										</div>
									</div>
									<div class="col-md-4">
										<div class="float-left col text-muted p-item"> 
											<small>{{ $t('MdPatientRegistrationInfo.DischargeDate') }}</small><br>
											<b>{{RegistrationInfo.dateTo}}</b>
											</div>
									</div>
									<div class="col-md-4" v-if="RegistrationInfo.status">
										<div class="float-left col text-muted p-item">
											<small>{{ $t('Shared.Status') }}</small><br>
											<b>{{RegistrationInfo.status}}</b>
										</div>
									</div>
									<div class="col-md-4" v-if="RegistrationInfo.chartNo">
										<div class="float-left col text-muted p-item">
											<small>{{ $t('Clinical.ChartNo') }}</small><br>
											<b>{{RegistrationInfo.chartNo}}</b>
										</div>
									</div>
									<div class="col-md-4" v-if="RegistrationInfo.buildingName">
										<div class="float-left col text-muted p-item">
											<small>{{ $t('Shared.BuildingName') }}</small><br>
											<b>{{RegistrationInfo.buildingName}}</b>
										</div>
									</div>	
									<div class="col-md-4" v-if="RegistrationInfo.roomName">
										<div class="float-left col text-muted p-item">
											<small>{{ $tc('Shared.Room') }}</small><br>
											<b>{{RegistrationInfo.roomName}}</b>
										</div>
									</div>
									<div class="col-md-4" v-if="RegistrationInfo.track">
										<div class="float-left col text-muted p-item">
											<small>{{ $tc('Admission.Track') }}</small><br>
											<b>{{RegistrationInfo.trackDescription}}</b>
										</div>
									</div>																
								</div>
							</div>
						</div>
						</div>
						<DxPopup 
							:visible="isReportPatientFaceSheetVisible"
							:drag-enabled="true"
							:close-on-outside-click="false"
							:show-close-button="true"
							:show-title="true"
							:hide-on-parent-scroll="true"
							:title="reportTitle"
							@hidden="onHiddenReport"
							:resize-enabled="true"
							shading-color="rgba(0, 0, 0, 0.5)"
							height="94vh"
							width="97vw"
							@showing="onShowing"
						>
							<ReportViewer
							ref="PatientFaceSheetRep"
							:ReportName="'PatientFaceSheet'"
							:ReportTitle="reportTitle"
							:IsAnAPIReport="true"
							/>
						</DxPopup>
					</div>
</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils.js';
import { DxPopup } from 'devextreme-vue/popup';

export default {
    props: {
     RecordId: String
   },
    mixins: [DBFunctions],
	components: { DxPopup },
    data() {
      return {
		RegistrationInfo:{},
		isReportPatientFaceSheetVisible: false,
		reportTitle: 'Patient Face Sheet by Admission',
      }
    },
    
  methods:{
	onShowing(e) {
		let contentElement = e.component.content();
        let titleElement = e.component._$title[0]
        contentElement.style.padding = '0px';
        titleElement.style.padding = '0px 20px'
    },

	onHiddenReport() {
		this.isReportPatientFaceSheetVisible = false
    },

	DoReport() {
		this.reportParams = []

        this.reportParams.push({ paramName: 'PatientCodeList', paramValue: this.RegistrationInfo.patientCode})
		this.reportParams.push({ paramName: 'AdmissionRecordId', paramValue: this.RegistrationInfo.recordId})
		this.reportParams.push({ paramName: 'ActivePatient', paramValue: ''})
        this.reportParams.push({ paramName: 'ActiveAdmission', paramValue: ''})
		this.reportParams.push({ paramName: 'byadmission', paramValue: 'Y'})
        
        this.isReportPatientFaceSheetVisible = true
        this.$refs.PatientFaceSheetRep.buildDocument(this.reportParams)
	},
  
	async getPatientInfo(){
		this.RegistrationInfo = await this.getRegistrationInfo(this.RecordId);
		if(this.RegistrationInfo.dateFrom)
			this.RegistrationInfo.dateFrom = Utils.formatterDateToString(this.RegistrationInfo.dateFrom);
		if(this.RegistrationInfo.dateTo)
			this.RegistrationInfo.dateTo = Utils.formatterDateToString(this.RegistrationInfo.dateTo);	
	
	},
	GoToAdmissionInfo(){
		if(this.$route.name.includes('Clinical')){
			this.$router.push({ name: "admission-clinical", params: { id: this.$route.params.id,recordid:this.$route.params.recordid } }).catch(()=>{});
		}

		if(this.$route.name.includes('appointmentDB-Dashboard')){			
			this.$router.push({ name: "appointmentDB-admissionList", params: { id: this.$route.params.id,actId:this.$route.params.actId } }).catch(()=>{});
		}
       
    },
  },
   mounted() {
	this.getPatientInfo();
   }
}

</script>